<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="selectFileDialog"
      append-to-body
      class="SelectFileDialog"
      title="选择文件"
      width="400px">
    <el-form
        ref="formUplosd"
        enctype="multipart/form-data"
        label-position="right"
        label-width="120px"
        size="mini">
      <el-upload
          action=""
          multiple
          :on-change="fileChange"
          :auto-upload="false"
          :show-file-list="true"
          :file-list="fileList">
        <el-button :loading="exportLoading" type="primary" plain style="margin-left: 5px">点击上传文件</el-button>
      </el-upload>
    </el-form>
    <div slot="footer">
      <el-button type="primary" plain :loading="exportLoading" @click="downLoadFile">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import loginUtil from "@/util/loginUtil";

  export default {
    components: {},
    data() {
      return {
        fileList: [],
        selectFileDialog: false,
        exportLoading:false,
      };
    },
    methods: {
      fileChange(file, fileList) {
        this.fileList = fileList;
      },

      open(){
        this.selectFileDialog=true;
      },

      downLoadFile() {
        //导入
        this.exportLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        this.fileList.forEach(item => {
          formData.append("file", item.raw);
        });
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .postForFile("basic", "sd/so/sendMessageByAddressDaily", formData)
          .then((res) => {
            let blob = new Blob([res.data]);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, "项目信息表.zip");
            } else {
              let a = document.createElement("a");
              a.href = window.URL.createObjectURL(blob);
              a.download = "项目信息表.zip";
              a.click();
              window.URL.revokeObjectURL(a.href);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });

      },
    },
  };
</script>

<style>
.createDeliveryBillDialog .el-dialog__body {
  padding: 10px 20px;
}

.createDeliveryBillDialog .el-tabs__header {
  margin: 0 0 10px;
}

.messageBox {
  z-index: 9999 !important;
}
</style>
